export const styles = {
  searchContainer: 'tw-mb-4',
  resultsContainer: 'tw-border tw-border-neutral-200 tw-rounded-md tw-max-h-60 tw-overflow-y-auto',
  resultsList: 'tw-divide-y tw-divide-neutral-200 tw-pl-0',
  resultItem: 'tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-neutral-50 tw-flex tw-items-center tw-justify-between tw-gap-3',
  resultItemContent: 'tw-min-w-0 tw-flex-1',
  resultItemName: 'tw-font-medium tw-text-neutral-900',
  resultItemEmail: 'tw-text-neutral-500 tw-text-xs',
  resultItemCta: 'tw-shrink-0',
  emptyResults: 'tw-px-3 tw-py-4 tw-text-sm tw-text-neutral-500 tw-text-center',
  noSearchYet: 'tw-px-3 tw-py-4 tw-text-sm tw-text-neutral-400 tw-text-center',
};
